<template>
  <div class="box-sign-up">

    <b-modal
      class="dsModal"
      id="modalRecoverPasswordFeedback"
      ref="modalRecoverPasswordFeedback"
      :hide-footer="true"
      :hide-header="true"
      centered
      ok-only
    >
      <ResetFeedbackMessage :customerEmail="passwordRecoveryEmail" :here="'signup-trial'" />
    </b-modal>

    <b-modal
      class="dsModal"
      id="modalRecoverPassword"
      ref="modalRecoverPassword"
      :hide-footer="true"
      centered
      ok-only
      hide-header
    >
      <template v-slot:default>
        <h2>Lost your password?</h2>
        <p>
          Enter your email address and we'll send you a link to create a new
          password.
        </p>
        <b-form
          style="text-align: left"
          @submit.prevent="submitRecoverPassword"
          ref="recoverPasswordForm"
          aria-autocomplete="off"
        >
          <!-- E-mail Input -->
          <b-input-group class>
            <span class="formIcons email">
              <EmailIcon />
            </span>
            <b-form-input
              v-model="$v.formRecoverPassword.email.$model"
              @keypress="errors.recoveryEmail = false"
              type="email"
              name="email"
              class="LoginInput"
              size="lg"
              placeholder="E-MAIL"
              :state="validateRecoveryEmail('email')"
              aria-describedby="email-feedback"
            ></b-form-input>
            <b-form-invalid-feedback
              id="email-feedback"
              v-bind:tooltip="false"
            >Must be a valid email address.</b-form-invalid-feedback>
          </b-input-group>
          <b-alert
            variant="error"
            v-model="errors.recoveryEmail"
          >This email is not associated with any account</b-alert>
          <button class="button-login" type="submit" id="submitRecoverPassword">
            <b-spinner v-show="showLoad"></b-spinner>
            <span id="button-text" v-if="!showLoad">Reset password</span>
          </button>
          <a
            href="https://dropsmarteo.com/support"
            target="_blank"
            class="support"
          >Still having problems? Click here for more information.</a>
        </b-form>
      </template>
    </b-modal>

    <b-modal
      class="dsModal"
      id="modalLogin"
      ref="modalLogin"
      centered
      ok-only
      no-stacking
      hide-header
    >
      <template v-slot:default>
        <h2>Log in to DROPSMART</h2>
        <b-form
          style="text-align: left"
          @submit.prevent="submitLogin"
          ref="loginForm"
          aria-autocomplete="off"
        >
          <!-- E-mail Input -->
          <b-input-group class>
            <span class="formIcons email">
              <EmailIcon />
            </span>
            <b-form-input
              v-model="$v.formLogin.email.$model"
              type="email"
              name="email"
              class="LoginInput"
              size="lg"
              placeholder="E-MAIL"
              :state="validateLogin('email')"
              aria-describedby="email-feedback"
            ></b-form-input>
            <b-form-invalid-feedback
              id="email-feedback"
              v-bind:tooltip="false"
            >Must be a valid email address.</b-form-invalid-feedback>
          </b-input-group>
          <!-- Password Input -->
          <b-input-group class>
            <span class="formIcons password">
              <PasswordIcon />
            </span>
            <b-form-input
              class="LoginInput"
              size="lg"
              v-model="$v.formLogin.password.$model"
              type="password"
              name="password"
              placeholder="PASSWORD"
              :state="validateLogin('password')"
              aria-describedby="password-feedback"
            ></b-form-input>
            <b-form-invalid-feedback
              id="password-feedback"
              v-bind:tooltip="false"
            >Your password must be at least 6 characters.</b-form-invalid-feedback>
          </b-input-group>
          <b-alert variant="error" :show="formLogin.loginAuthError">Invalid email or password</b-alert>
          <button class="button-login" type="submit" id="submitLogin">
            <b-spinner v-show="showLoad"></b-spinner>
            <span class id="button-text" v-if="!showLoad">LOG IN</span>
          </button>
        </b-form>
      </template>

      <template v-slot:modal-footer>
        <a href="#" class="forgot-password" v-b-modal.modalRecoverPassword>Forgot your password?</a>
      </template>
    </b-modal>

    <DefaultVideoComponent :videoUrl="videoUrl" style="margin-bottom: 2em;"/>


    <div v-if="this.routeName != 'GiftCard'" style="font-weight: 600; font-style: italic; margin-bottom: 1em;">
      As soon as you fill out this form, we'll activate your trial and you'll get immediate access to all of Dropsmart's Premium features. No credit card is needed & there aren't any hidden fees.
    </div>
    <div v-if="this.routeName == 'GiftCard'">
    <h2 style="font-weight: 700; font-size: 1.8rem; margin-top: 0;">Activate your gift card below</h2>
    <h4 style="margin-bottom: 1em;">Fill out the form below to activate your Gift Card.</h4>
    <p style="font-size: 1.37rem">
      As soon as you fill out this form, we'll activate your gift card, and you'll get immediate access to all of Dropsmart's Premium features for full 90 days. No credit card is needed & there aren't any hidden fees.
      </p>
      <p style="font-size: 1.37rem; margin-bottom: 1em;">
      No credit card is needed & there aren't any hidden fees.
      </p>
    </div>
    <!--div v-if="!this.existingCustomerInfo.loaded && this.routeName != 'GiftCard'" class="box-login">
      <h2 class="login-title" style="text-align: left; padding: 0px 0 15px;">Login</h2>
      <p style="margin-top: 0">
        Do you have an account? Click here to
        <a href="#" v-b-modal.modalLogin role="button">Log In</a>.
      </p> 
    </div-->
    <AfterLogin
      v-if="this.existingCustomerInfo.loaded"
      v-bind:user="existingCustomerInfo"
      v-on:logoff="logoff"
    />

    <b-card body-border-variant="danger" v-if="hasTrial" class="box-login">
      This email is already associated with a trial account. Click <a href="https://center.dropsmarteo.com/login" role="button">here</a> to login.
    </b-card>

    <h2 class="login-title" style="text-align: left"    
      v-if="!this.existingCustomerInfo.loaded && this.routeName != 'GiftCard'">Create Your Account</h2>
    <b-form
      style="text-align: left"
      aria-autocomplete="off"
      @submit.prevent="submitSignup"
    >
    <div v-if="!this.existingCustomerInfo.loaded">
      <!-- First Name Input -->
      <b-input-group class>
        <span class="formIcons">
          <UserIcon />
        </span>
        <b-form-input
          ref="firstNameInput"
          name="firstName"
          v-model="$v.form.firstName.$model"
          :state="validateInput('firstName')"
          class="LoginInput"
          size="lg"
          placeholder="First name"
          aria-describedby="firstName-feedback"
        ></b-form-input>
        <b-form-invalid-feedback id="firstName-feedback" v-bind:tooltip="false"
          >This is a required field.</b-form-invalid-feedback
        >
      </b-input-group>
      
      <!-- Last Name Input -->
      <b-input-group class>
        <span class="formIcons">
          <UserIcon />
        </span>
        <b-form-input
          name="lastName"
          v-model="$v.form.lastName.$model"
          :state="validateInput('lastName')"
          class="LoginInput"
          size="lg"
          placeholder="Last name"
          aria-describedby="lastName-feedback"
        ></b-form-input>
        <b-form-invalid-feedback id="lastName-feedback" v-bind:tooltip="false"
          >This is a required field.</b-form-invalid-feedback
        >
      </b-input-group>

      <!-- E-mail Input -->
      <b-input-group class>
        <span class="formIcons email">
          <EmailIcon />
        </span>
        <b-form-input
          type="email"
          name="email"
          class="LoginInput"
          size="lg"
          v-model="$v.form.email.$model"
          :state="validateInput('email')"
          @blur="checkEmail()"
          placeholder="E-mail"
          aria-autocomplete="off"
          aria-describedby="email-feedback"
        ></b-form-input>
        <div v-show="this.emailIsRegistered && this.routeName != 'GiftCard'" class="invalid-feedback-custom box-login">
          This email is already associated with a Dropsmart's account. Please,
          <!--a href="#" v-b-modal.modalLogin role="button">sign in here</a>.-->
          <a href="https://app.dropsmarteo.com/login" role="button">sign in here</a>.
        </div>
        <div v-show="this.emailIsRegistered && this.routeName == 'GiftCard'" class="invalid-feedback-custom box-login">
          This email is already associated with a Dropsmart's account. This gift card is valid for first-comers only. Please,
          <a href="dsAppUrl">sign in here</a>.
        </div>
        <b-form-invalid-feedback id="email-feedback" v-bind:tooltip="false"
          >Must be a valid email address.</b-form-invalid-feedback
        >
      </b-input-group>

      <!-- Password Input -->
      <b-input-group class>
        <span class="formIcons password">
          <PasswordIcon />
        </span>
        <b-form-input
          class="LoginInput"
          size="lg"
          type="password"
          name="password"
          v-model="$v.form.password.$model"
          :state="validateInput('password')"
          placeholder="Create password"
          aria-autocomplete="off"
          aria-describedby="password-feedback"
        ></b-form-input>
        <b-form-invalid-feedback id="password-feedback" v-bind:tooltip="false">
          Your password must be at least 6 characters.
        </b-form-invalid-feedback>
      </b-input-group>
      <!-- Newsletter accept -->
      <b-form-group class="signup-checkbox"
          v-if="!existingCustomerInfo.loaded">
        <b-form-checkbox
          id="acceptTerms"
          v-model="$v.form.acceptTerms.$model"
          name="acceptTerms"
          :state="validateInput('acceptTerms')"
          aria-describedby="terms-conditions-feedback"
        >
          I agree to Dropsmart's
          <a target="_blank" :href="termsAndConditionsUrl"
            >terms and conditions</a
          >
        </b-form-checkbox>

        <b-form-checkbox
          v-if="!existingCustomerInfo.loaded"
          id="acceptNewsletter"
          name="acceptNewsletter"
          v-model="form.subscribeToMailGroup"
        >I wish to receive email guidance on how to utilize the power of the Dropsmart during my trial period.
        </b-form-checkbox>
      </b-form-group>

      <div class="textGDPR" v-if="!existingCustomerInfo.loaded">
        <p>
          We respect the GDPR rules. Your privacy is important to us. We don't send spam, and you can unsubscribe at any time.
        </p>
      </div>

    </div>

      <button class="button-login button-continue" type="submit" id="submitLogin" :disabled="submitDisabled" v-if="!hasTrial" >
        <b-spinner v-show="showLoad"></b-spinner>
        <span class id="button-text" v-if="!showLoad">Continue</span>
      </button>
      <div style="font-style: oblique; text-align: left; margin-top: 1em;" class="textGDPR">
        Launched in 2016, Dropsmart (formerly Dropsmith) is the <b>Most Trusted Essential Oil Resource Center</b> used in over 80 countries by thousands of aromatherapy experts and established brands.
      </div>
    </b-form>

    <StandardLeft :routeName="routeName" v-if="this.routeName == 'GiftCard'"/>


  </div>
</template>

<script>
import AfterLogin from "@/components/login/AfterLogin.vue";
import PasswordIcon from "./icons/PasswordIcon.vue";
import EmailIcon from "./icons/EmailIcon.vue";
import UserIcon from "./icons/UserIcon.vue";
import ResetFeedbackMessage from "@/components/ResetFeedbackMessage.vue";
import StandardLeft from "@/components/checkout/standard/StandardLeft.vue";
import { BACKEND_URL, FRONTEND_URL } from "../config.js";
import DefaultVideoComponent from '@/components/centre/DefaultVideoComponent.vue';


import { validationMixin } from "vuelidate";

import { required, requiredIf, minLength, email } from "vuelidate/lib/validators";

export default {
  props: ['routeName'],
  components: {
    PasswordIcon,
    EmailIcon,
    UserIcon,
    AfterLogin,
    ResetFeedbackMessage,
    StandardLeft,
    DefaultVideoComponent,
  },
  mixins: validationMixin,
  validations: {
    formLogin: {
      email: {
        required,
        email,
      },
      password: {
        required,
        minLength: minLength(6),
      },
    },
    formRecoverPassword: {
      email: {
        required,
        email,
      },
    },
    form: {
      firstName: {
        required,
        minLength: minLength(2),
      },
      lastName: {
        required,
        minLength: minLength(2),
      },
      email: {
        required,
        email,
      },
      acceptTerms: {
        required: requiredIf(function (form) {
          form;
          let req = !this.existingCustomerInfo.loaded;

          console.log('acceptTerms is required ' + req);

          return req;
        }),
      },
      password: {
        required: requiredIf(function (form) {
          form;
          let isRequired = !this.existingCustomerInfo.loaded;
          return isRequired;
        }),
        minLength: minLength(6),
      }
    },
  },
  computed: {
    hasTrial: function() {
      return this.existingCustomerInfo.trialId && this.existingCustomerInfo.trialId !== 0;
    },
    validForm: function () {
      return !this.$v.form.$anyError;
    },
    validLoginForm: function () {
      return !this.$v.formLogin.$anyError;
    },
    validRecoveryForm: function () {
      return !this.$v.formRecoverPassword.$anyError;
    },
    submitDisabled: function() {
      return !this.validForm || this.hasTrial;
    },
  },
  data() {
    return {
      emailIsRegistered: false,
      showLoad: false,
      termsAndConditionsUrl: BACKEND_URL.TermsAndConditions,
      dsAppUrl: FRONTEND_URL.AppLoginPage,
      videoUrl: "https://player.vimeo.com/video/826002422",       
      // after the user types in the email address, an attempt will be made
      // to fetch the account data already existing for that email. If an
      // existing account is found, this object will hold the details.
      existingCustomerInfo: {
        loaded: false,
        stripeId: null,
        firstName: null,
        lastName: null,
      },
      form: {
        firstName: null,
        lastName: null,
        email: null,
        password: null,
        isNewAccount: true,
        acceptTerms: null,
        subscribeToMailGroup: false,
        lrefereer: null,
        isTrial: true,
      },
      formLogin: {
        email: null,
        password: null,
        loginAuthError: false,
      },
      formRecoverPassword: {
        email: null,
      },
      errors: {
        recoveryEmail: false,
        emailIsRegistered: false,
      },
      recoveryEmailWasSent: false,
      passwordRecoveryEmail: null,
    };
  },
  methods: {

    validateRecoveryEmail(name) {
      const { $dirty, $error } = this.$v.formRecoverPassword[name];
      return $dirty ? !$error : null;
    },

    validateLogin(name) {
      const { $dirty, $error } = this.$v.formLogin[name];
      return $dirty ? !$error : null;
    },

    submitSignup() {
      this.$v.form.$touch();
      console.log('form.$error is ' + this.$v.form.$anyError);
      if (!this.validForm) {
        return;
      }
      this.showLoad = true;

      let url = BACKEND_URL.FreeSignup;
      console.log("SUBMITING THE SIGNUP FORM TO " + url);
      
      if (this.existingCustomerInfo.loaded) {
        this.$parent.$emit('AccountCreated', JSON.parse(sessionStorage.getItem('customerInfo')));
        return;
      }

      //get contactId from the url
      var ontraportContactId = new URL(location.href).searchParams.get('orid');
      if( ontraportContactId != null) {
        this.form.lrefereer = ontraportContactId
        console.log("LREFEREER -> " + this.form.lrefereer)
      }

      console.log("JSON content: " + JSON.stringify(this.form));
    
      fetch(BACKEND_URL.FreeSignup, {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(this.form),
        headers: { "Content-type": "application/json" },
        cache: "no-cache",
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            if (response.status == 409) {
              console.log("Email already exists");
            }
            throw Error(response.status + ": " + response.statusText);
          }
        })
        .then(loginData => {
            this.$parent.$emit('AccountCreated', loginData);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.showLoad = false;
        });
    }, 
    submitLogin() {
      this.$v.formLogin.$touch();
      if (!this.validLoginForm) {
        return;
      }

      let modal = this.$refs.modalLogin;

      this.showLoad = true;
      this.formLogin.loginAuthError = false;

      fetch(BACKEND_URL.Login, {
        method: "POST",
        body: JSON.stringify(this.formLogin),
        headers: {
          "Content-type": "application/json",
        },
        credentials: "same-origin",
        cache: "no-cache",
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            if (response.status == 401) {
              this.formLogin.loginAuthError = true;
            }
            throw Error(response.status + ": " + response.statusText);
          }
        })
        .then((loginResponse) => {
          this.showLoad = false;
          this.emailIsRegistered = false;
          sessionStorage.setItem("customerInfo", JSON.stringify(loginResponse));
          this.existingCustomerInfo.loaded = true;
          this.existingCustomerInfo.trialId = loginResponse.user.trialId;
          this.existingCustomerInfo.stripeId = loginResponse.user.stripeId;
          this.existingCustomerInfo.firstName = loginResponse.user.firstName;
          this.existingCustomerInfo.lastName = loginResponse.user.lastName;

          this.form.firstName = loginResponse.user.firstName;
          this.form.lastName = loginResponse.user.lastName;
          this.form.email = loginResponse.user.email;
          modal.hide();

        })
        .catch((error) => {
          this.showLoad = false;
          console.error(error);
        });
    },
    logoff() {
      this.existingCustomerInfo.loaded = false;
      this.existingCustomerInfo.firstName = null;
      this.existingCustomerInfo.lastName = null;
      this.existingCustomerInfo.email = null;
      this.existingCustomerInfo.stripeId = null;
      this.emailIsRegistered = false;
      this.form.firstName = null;
      this.form.lastName = null;
      this.form.email = null;
      this.form.password = null;
      this.$v.$reset();
      sessionStorage.removeItem("customerInfo");
    },
    resetPasswordRecovery() {
      this.recoveryEmailWasSent = false;
      this.formRecoverPassword.email = null;
      this.errors.recoveryEmail = null;
    },
    submitRecoverPassword() {
      this.$v.formRecoverPassword.$touch();
      if (!this.validRecoveryForm) {
        return;
      }

      let email = this.formRecoverPassword.email;
      let url = BACKEND_URL.RecoverPasswordInfo + "?email=" + email;
      this.showLoad = true;
      fetch(url, {
        method: "POST",
        mode: "cors",
      })
        .then((response) => {
          if (response.ok) {
            this.recoveryEmailWasSent = true;
            this.passwordRecoveryEmail = email;
            this.$refs.modalRecoverPassword.hide();
            this.$refs.modalRecoverPasswordFeedback.show();
          } else if (response.status == 404) {
            this.showLoad = false;
            this.recoveryEmailWasSent = false;
            this.errors.recoveryEmail = true;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    checkEmail() {
      if (!this.form.email) {
        return;
      }
      let url = BACKEND_URL.CheckEmail + "?email=" + this.form.email;
      console.log("checking " + url);
      fetch(url, {
        method: "GET",
        mode: "cors",
      })
        .then((response) => {
          if (response.ok || response.status == 204) {
            this.emailIsRegistered = response.status != 204;
          } else {
            throw Error(response.status + " " + response.statusText);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    validateInput(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
  },  
  mounted() {
    this.emailIsRegistered = false;
    this.$v.form.$reset();

    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      bvEvent, modalId;
      this.resetPasswordRecovery();
    });
    this.logoff();
  },
};
</script>

<style lang="scss">
</style>